import { store } from '~/store';


export const apiKey = () => store.state.auth.key;
export const currentUser = () => store.state.auth.user;
export const loginType = () => store.state.auth.type;
export const getLoginPermissions = () => store.state.permissions.login;
export const genericConfigByKey = key => store.getters['genericConfig/byKey'](key);
export const apiUrl = () => store.state.apiUrl.url;
export const publicConfig = () => store.state.publicConfig.config;
export const getRouterParams = () => store.state.router.params;
export const getStatuses = () => store.state.statuses.statuses;



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/store/getters.js